import { render, staticRenderFns } from "./bar-y.vue?vue&type=template&id=43db8fe3&"
import script from "./bar-y.vue?vue&type=script&lang=js&"
export * from "./bar-y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports